import Marquee from "react-fast-marquee";

const ITEMS = [
    "Grabación de vídeo",
    "Fotografía",
    "Gestión de redes",
    "Sitios web",
    "Guiones e ideas",
    "Edición",
    "Alicante",
];

export const EditorialMarquee = () => {
    return (
        <div className="py-10 md:py-14 border-y border-line overflow-hidden" aria-hidden="true">
            <Marquee speed={25} gradient={false}>
                {ITEMS.map((item) => (
                    <span
                        key={item}
                        className="font-display text-5xl md:text-7xl lg:text-8xl font-bold text-stroke-navy mx-8 md:mx-14 whitespace-nowrap"
                    >
                        {item} <span className="text-coral" style={{ WebkitTextStroke: "0" }}>✦</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
};
